import { IEconomicCalendarDto } from "@/components/Footer/components/Toolbar/EconomicCalendar/api/economicCalendarApi";
import {
    ISetCountriesAction,
    ISetDataAction,
    ISetSelectedCountryAction,
    ISetSelectedImpactLevelAction,
} from "../reducers/economicCalendarReducer";
import { EconomicCalendarActionTypes } from "../reducers/economicCalendarReducer";
import { ImpactLevels } from "@/components/Footer/components/Toolbar/EconomicCalendar/ui/ImpactLevelSelect";

export const setEconomicCalendarData = (
    data: Record<string, IEconomicCalendarDto[]>
): ISetDataAction => ({
    type: EconomicCalendarActionTypes.SET_DATA,
    data,
});

export const setEconomicCalendarCountries = (countries: {
    icon: string;
    label: string;
}[]): ISetCountriesAction => ({
    type: EconomicCalendarActionTypes.SET_COUNTRIES,
    countries,
});

export const setEconomicCalendarSelectedCountry = (country: string): ISetSelectedCountryAction => ({
    type: EconomicCalendarActionTypes.SET_SELECTED_COUNTRY,
    selectedCountry: country,
});

export const setEconomicCalendarSelectedImpactLevel = (
    impactLevel: ImpactLevels
): ISetSelectedImpactLevelAction => ({
    type: EconomicCalendarActionTypes.SET_SELECTED_IMPACT_LEVEL,
    selectedImpactLevel: impactLevel,
});
